module.exports = __webpack_public_path__ + "img/stock.69a65133.svg";